import type { JobStatus } from '@/services/types';

const MAP: Record<JobStatus | string, string> = {
  new: 'badge-gray',
  applying: 'badge-amber',
  applied: 'badge-green',
  failed: 'badge-red',
  skipped: 'badge-gray',
  interview: 'badge-blue',
  offer: 'badge-green',
  rejected: 'badge-red',
};

export function StatusBadge({ status }: { status: JobStatus | string | null }) {
  if (!status) return null;
  return <span className={MAP[status] ?? 'badge-gray'}>{status}</span>;
}
